export const HeadCells = [
  {
    field: "name",
    headerTitle: "Name",
  },
  {
    field: "username",
    headerTitle: "User Name",
  },
  // {
  //   field: "email",
  //   headerTitle: "Email",
  // },
  {
    field: "password",
    headerTitle: "Password",
  },
  {
    field: "accountType",
    headerTitle: "Account Type",
  },
  {
    field: "paymentStatus",
    headerTitle: "Payment Status",
  },
  {
    field: "paymentDate",
    headerTitle: "Payment Date",
  },
];
